<template>
	<div class="tab-page">
		<div class="registration-inner">
			<span>{{$t('contact-gualchieri')}}</span>
			<a id="email" href="mailto:commerciale@gualchieriegualchieri.it">commerciale@gualchieriegualchieri.it</a>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Registration'
}
</script>

<style scoped>
.registration-inner {
	text-align: center;
	padding: 3.2rem 0;
}

#email {
	display: block;
	font-size: 2.4rem;
	margin-top: .8rem;
}
</style>